import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';

import { useTooltip } from './context';

/**
 * @param {Object} props
 * @param {import('utils/types').TooltipPlacement} props.placement
 * @param {boolean} props.fade
 * @param {number | Record<'show' | 'hide', number>} props.delay
 * @param {"scrollParent" | "window" | "viewport"} props.boundariesElement
 * @param {number | string} props.offset
 * @param {boolean} props.autohide
 * @param {string} props.className
 * @param {string} props.tooltipClassName
 * @param {string} props.innerClassName
 * @param {string} props.arrowClassName
 * @param {React.ReactNode} [props.children=null]
 */
export default function TooltipContent({
  placement = 'top',
  children = null,
  ...tooltipProps
}) {
  const { id, isMounted } = useTooltip();

  if (!isMounted || !children) {
    return null;
  }

  return (
    <UncontrolledTooltip target={id} placement={placement} {...tooltipProps}>
      {children}
    </UncontrolledTooltip>
  );
}
